/*
 *
 * glossaryAPI.js
 *
 */

import Axios from "axios";

const glossaryAPI = {
  fetchByID: async (data) =>
    await Axios.get(
      `${window.API_URL}/glossary/get.php?glossaryID=${data.glossaryID}`
    ),
  create: async (data) => {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("note", data.note);
    formData.append("sourceLang", data.sourceLang);
    formData.append("file", data.file);
    formData.append("sourceColumn", data.sourceColumn);
    formData.append("targets", JSON.stringify(data.targets ?? []));
    //formData.append("rowCount", data.rowCount);

    return await Axios.post(
      `${window.API_URL}/glossary/createNew.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        /*
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                if (data.setProgress) data.setProgress(percentCompleted); // Update progress
                
            }*/
      }
    );
  },
  fetchByTitle: async (data) =>
    await Axios.get(
      `${window.API_URL}/glossary/get.php?titleID=${data.titleID}`
    ),
  fetchByProject: async (data) =>
    await Axios.get(
      `${window.API_URL}/glossary/get.php?projectID=${data.projectID}`
    ),
  fetchByTask: async (data) =>
    await Axios.get(`${window.API_URL}/glossary/get.php?taskID=${data.taskID}`),
  fetchAll: async () => await Axios.get(`${window.API_URL}/glossary/get.php`),
  assignToTitle: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/assign.php`, {
      titleID: data.titleID,
      glossaryID: data.glossaryID,
    }),
  unassign: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/unassign.php`, {
      titleID: data.titleID,
      projectID: data.projectID,
      glossaryIDs: data.glossaryIDs,
    }),
  addTerm: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/addTerm.php`, {
      glossaryID: data.glossaryID,
      source: data.source, //Optional, can be undefined
      target: data.target, //Optional, can be undefined
      taskID: data.taskID, //Optional, can be undefined
    }),
  addTermToTask: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/addTerm.php`, {
      glossaryID: data.glossaryID,
      source: data.source,
      target: data.target,
      taskID: data.taskID,
      note: data.note,
    }),
  removeTerms: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/removeTerms.php`, {
      termIDs: data.termIDs,
    }),
  assignToProject: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/assign.php`, {
      projectID: data.projectID,
      glossaryID: data.glossaryID,
    }),
  setContractorWrite: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/setContractorWrite.php`, {
      glossaryIDs: data.glossaryIDs,
      contractorWrite: data.contractorWrite,
      projectID: data.projectID,
      titleID: data.titleID,
    }),
  saveModifications: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/saveModifications.php`, {
      id: data.id,
      source: data.source,
      target: data.target,
    }),
  setName: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/setName.php`, {
      glossaryID: data.glossaryID,
      glossaryName: data.glossaryName,
    }),
  delete: async (data) =>
    await Axios.post(`${window.API_URL}/glossary/delete.php`, {
      glossaryID: data.glossaryID,
    }),
};

export default glossaryAPI;
